import { render, staticRenderFns } from "./AdmissionsStudentList.vue?vue&type=template&id=563baf84&scoped=true"
import script from "./AdmissionsStudentList.vue?vue&type=script&lang=js"
export * from "./AdmissionsStudentList.vue?vue&type=script&lang=js"
import style0 from "./AdmissionsStudentList.vue?vue&type=style&index=0&id=563baf84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563baf84",
  null
  
)

export default component.exports